import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';
import { getUserAccessByEmail as getUserAccessRecord } from './firestoreService';

export const normalizeUserEmail = (email) =>
  typeof email === 'string' ? email.trim().toLowerCase() : '';

export const getUserAccessByEmail = async (email) => {
  const normalizedEmail = normalizeUserEmail(email);

  if (!normalizedEmail) {
    return null;
  }

  return getUserAccessRecord(normalizedEmail);
};

export const syncUserLoginLifecycle = async () => {
  const syncLogin = httpsCallable(functions, 'syncUserLoginLifecycle');
  const result = await syncLogin();

  return result.data?.user || null;
};

export const getUserAccessByAuthUser = async (user) => {
  const normalizedEmail = normalizeUserEmail(user?.email);

  if (!user?.uid && !normalizedEmail) {
    return null;
  }

  return syncUserLoginLifecycle();
};
